import {
  completionYMMax,
  completionYMMin,
  dateMax,
  dateMin,
  estatePriceMax,
  estatePriceMin,
  roomsMax,
  roomsMin,
  squareAreaOfMansionMax,
  squareAreaOfMansionMin,
  tsuboAreaMax,
  tsuboAreaMin
} from "common/consts/estates";
import { format } from "date-fns";
import { BldConditionSelection } from "./BldConditionSelection";
import { EstateType } from "./EstateType";
import { PurposeSummaryB } from "./PurposeSummaryB";
import { StructureSummary } from "./StructureSummary";

export interface EstateFilterConditions {
  estateTypes: EstateType[];
  bldConditionSelections: BldConditionSelection[];
  structureSummaries: StructureSummary[];
  purposeSummaryBs: PurposeSummaryB[];
  companyRecNo: number;
  tsuboAreaFrom: number;
  tsuboAreaTo: number;
  squareAreaOfMansionFrom: number;
  squareAreaOfMansionTo: number;
  estatePriceFrom: number;
  estatePriceTo: number;
  createdAtFrom: number;
  createdAtTo: number;
  pricedAtFrom: number;
  pricedAtTo: number;
  alsoCreatedAtFrom: number;
  alsoCreatedAtTo: number;
  alsoPricedAtFrom: number;
  alsoPricedAtTo: number;
  completionYMFrom: number;
  completionYMTo: number;
  petOk: boolean;
  flat: boolean;
  forRent: boolean;
  exceptForRent: boolean;
  venderOnly: boolean;
  roomsFrom: number;
  roomsTo: number;
}

export const initialEstateFilterConditionsForDefault: Omit<
  EstateFilterConditions,
  | "estateTypes"
  | "bldConditionSelections"
  | "structureSummaries"
  | "purposeSummaryBs"
> = {
  companyRecNo: 0,
  tsuboAreaFrom: tsuboAreaMin,
  tsuboAreaTo: tsuboAreaMax,
  squareAreaOfMansionFrom: squareAreaOfMansionMin,
  squareAreaOfMansionTo: squareAreaOfMansionMax,
  estatePriceFrom: estatePriceMin,
  estatePriceTo: estatePriceMax,
  createdAtFrom: dateMin,
  createdAtTo: dateMax,
  pricedAtFrom: dateMin,
  pricedAtTo: dateMax,
  alsoCreatedAtFrom: dateMin,
  alsoCreatedAtTo: dateMax,
  alsoPricedAtFrom: dateMin,
  alsoPricedAtTo: dateMax,
  completionYMFrom: Number(format(completionYMMin, "yyyyMM")),
  completionYMTo: Number(format(completionYMMax, "yyyyMM")),
  petOk: false,
  flat: false,
  forRent: false,
  exceptForRent: false,
  venderOnly: false,
  roomsFrom: roomsMin,
  roomsTo: roomsMax,
};

export const initialEstateFilterConditions: EstateFilterConditions = {
  estateTypes: [],
  bldConditionSelections: [],
  structureSummaries: [],
  purposeSummaryBs: [],
  ...initialEstateFilterConditionsForDefault
};
